import { SectionBackground } from '@components/SectionBackground';
import { markdownBlockClassName, markdownComponents } from '@components/contentBlock/markdownBlock';
import { SimpleLink } from '@components/simpleLink';
import type * as React from 'react';
import ReactMarkdown from 'react-markdown';
import { useFragment } from 'react-relay';
import SectionNavigation from '../../../sectionNavigation';
import { pageSectionClassName } from '../PageSectionsStyles';
import { homeFundIntroductionSectionFragment } from './HomeFundIntroductionSection.relay';
import type { HomeFundIntroductionSectionPropsType } from './types';

const HomeFundIntroductionSection: React.FC<HomeFundIntroductionSectionPropsType> = (props: HomeFundIntroductionSectionPropsType) => {
  const pageSection = useFragment(homeFundIntroductionSectionFragment, props.pageSection);

  const country = props.salesAdmission || props.userCountry;
  const homeFundIntroductionData = pageSection.versions.find((data) => data.country.toUpperCase() === country.toUpperCase());

  return (
    <div className={pageSectionClassName}>
      {props.showImage && <SectionBackground anchorName={pageSection.anchorName} url={process.env.HOST + pageSection.titleImageUrl} backgroundUrl={process.env.HOST + pageSection.titleImageBackgroundUrl} />}
      <div className="section-content-wrapper Home-container">
        <div className="text-nav-wrapper">
          <div className="section-text">
            <h1 className="Base-title">{pageSection.title}</h1>
            <p>{homeFundIntroductionData.text}</p>
          </div>
          <SectionNavigation sectionNavigation={props.sectionNavigation} activeIndex={props.index} />
        </div>

        <h3 className="Base-subtitle">
          <span>{homeFundIntroductionData.subTitle}</span>
        </h3>

        <div className={markdownBlockClassName}>
          <ReactMarkdown components={markdownComponents}>{homeFundIntroductionData.subText}</ReactMarkdown>
        </div>

        <blockquote>{homeFundIntroductionData.quote}</blockquote>

        <div className="Home-quickLinks">
          <SimpleLink dropWrapper={true} simpleLink={homeFundIntroductionData.link1} />
          <SimpleLink dropWrapper={true} simpleLink={homeFundIntroductionData.link2} />
        </div>
      </div>
    </div>
  );
};

export { HomeFundIntroductionSection };
